import { BRAND_PROJECTS_LIST_BANNER_HEADER_MODULE_ID, BRAND_PROJECTS_LIST_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { GET_PROJECTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { SORT_BY_BOUNTY, SORT_BY_NEWEST, SORT_BY_TIME_LEFT } from 'root/src/shared/constants/sortTypes'
import { CREATE_PROJECT_ROUTE_ID, FILTER_DARES_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import {
	brandProjectsKey,
	activeKey,
	completedKey,
	projectDeliveryRejectedKey,
} from 'root/src/shared/constants/keys'
import { youtubeSearchDebounce } from 'root/src/shared/constants/youtube'

export default {
	[BRAND_PROJECTS_LIST_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		listModuleId: BRAND_PROJECTS_LIST_MODULE_ID,
		bannerImageText: 'Brand Dares',
		bannerImageSubText: 'Keep track of your Dares, Pledges, and Videos',
		bannerTabs: [
			{
				id: 1,
				tabLabel: 'Active',
				endpointId: [GET_PROJECTS],
				fixedPayload: {
					section: brandProjectsKey,
					subSection: activeKey,
				},
				needsTwitchAuth: false,
			},
			{
				id: 2,
				tabLabel: 'Completed',
				endpointId: [GET_PROJECTS],
				fixedPayload: {
					section: brandProjectsKey,
					subSection: completedKey,
				},
				needsTwitchAuth: false,
			},
			{
				id: 3,
				tabLabel: 'Rejected',
				endpointId: [GET_PROJECTS],
				fixedPayload: {
					section: brandProjectsKey,
					subSection: projectDeliveryRejectedKey,
				},
				needsTwitchAuth: false,
			},
		],
		createNewDareActive: true,
		link: {
			routeId: CREATE_PROJECT_ROUTE_ID,
			label: 'Create a New Dare +',
		},
		embeddedContent: {
			moduleType: 'embeddedForm',
			filtersRoute: FILTER_DARES_ROUTE_ID,
			fields: [
				{
					fieldId: 'sort',
					fieldCaption: 'Sort By:',
					fixedLargeWidth: true,
					inputType: 'dropdownEmbedded',
					options: [
						{
							label: 'Newest',
							id: 0,
							value: SORT_BY_NEWEST,
						},
						{
							label: 'Bounty Amount',
							id: 1,
							value: SORT_BY_BOUNTY,
						},
						{
							label: 'Time Left',
							id: 2,
							value: SORT_BY_TIME_LEFT,
						},
					],
					endpointId: [GET_PROJECTS],
				},
				{
					fieldId: 'game',
					fieldCaption: 'Filter By:',
					fixedSmallWidth: true,
					inputType: 'autoCompleteEmbedded',
					optionsPromiseType: 'twitchGames',
					placeholder: 'Game',
					endpointId: [GET_PROJECTS],
				},
				{
					inputType: 'variantFieldEmbedded',
					fieldId: 'assignee',
					fixedSmallWidth: true,
					placeholder: 'Creator',
					endpointId: [GET_PROJECTS],
					variantOptions: [
						{
							id: 'twitch',
							name: 'Twitch',
							optionsPromiseType: 'twitchChannels',
							inputType: 'autoCompleteEmbedded',
						},
						{
							id: 'youtube',
							name: 'YouTube',
							debounceDelay: youtubeSearchDebounce,
							optionsPromiseType: 'youtubeChannels',
							inputType: 'autoCompleteEmbedded',
						},
					],
				},
			],
		},
	},
}
